export default "__VITE_ASSET__6abeb07c__"